var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-chip-group',_vm._l((_vm.keyItems),function(keyItem){return _c('v-chip',{key:keyItem['value'],attrs:{"color":_vm.colors[keyItem['value']],"dark":""}},[_c('b',[_vm._v(_vm._s(keyItem['value']))])])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }